import React from 'react';

import {useGate, useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {ReactComponent as SettingsIcon} from 'assets/svg/options.svg';
import {Select} from 'components//ui-kit/Select';
import {Page} from 'components/common/Page';
import {isAdmin$} from 'models/auth';
import {dashboardState$, Gate, packageTypeChanged} from 'models/dashboard';
import {colors} from 'theme';

import {CUSTOMER_PACKAGE_TYPES} from 'types/gtins';

import {ProductDefectChart} from './Charts/ProductDefectChart';
import {ProductDynamicChart} from './Charts/ProductDynamicChart';
import {ProductStatusChart} from './Charts/ProductStatusChart';
import {ProductTopSquareChart} from './Charts/ProductTopSquareChart';
import {CheckCodeModal} from './CheckCodeModal';
import {Dates} from './Dates';
import {GoogleMap} from './GoogleMap';
import {
    BlockSettingsIcon,
    ChartBox,
    ContentWrapper,
    DatesContainer,
    PackageTypeContainer,
} from './styled';

export const OptionsIcon = () => (
    <BlockSettingsIcon width={20} fillColor={colors.brandPrimary} source={SettingsIcon} />
);

export function DashboardPage() {
    const {t} = useTranslation();
    const store = useStore(dashboardState$);
    const isAdmin = useStore(isAdmin$);
    useGate(Gate);

    const packageTypeOptions = CUSTOMER_PACKAGE_TYPES.map((type) => ({
        value: type,
        label: t(`dictionaries.products.packageType.${type}`),
    }));

    return (
        <Page title={t('pages.dashboard.title')}>
            <ContentWrapper>
                <DatesContainer>
                    <Dates />
                </DatesContainer>
                {isAdmin && <GoogleMap />}
                {/*<CheckCode>*/}
                {/*    <BlockTitle>{t('pages.dashboard.markingLegal')}</BlockTitle>*/}
                {/*    <CodeDropzone />*/}
                {/*</CheckCode>*/}
                <PackageTypeContainer>
                    <Select
                        options={packageTypeOptions}
                        value={packageTypeOptions.find((o) => o.value === store.packageType)}
                        isSearchable={false}
                        onChange={(v: typeof packageTypeOptions[number]) =>
                            packageTypeChanged(v.value)
                        }
                    />
                </PackageTypeContainer>
                <ChartBox>
                    <ProductDynamicChart
                        data={store.productDynamic}
                        total={store.productDynamicTotal}
                    />
                </ChartBox>
                <ChartBox>
                    <ProductStatusChart data={store.productStatus} />
                </ChartBox>
                <ChartBox>
                    <ProductDefectChart data={store.productDefect} />
                </ChartBox>
                <ChartBox>
                    <ProductTopSquareChart data={store.productTop} />
                </ChartBox>
                {/*<SearchBox>*/}
                {/*    <BlockTitle>{t('pages.dashboard.search.title')}</BlockTitle>*/}
                {/*    <CodeSearch />*/}
                {/*</SearchBox>*/}
                <CheckCodeModal />
            </ContentWrapper>
        </Page>
    );
}
